import React from 'react';
import PbssChapterContainer from '../../../Containers/UserContainer/PbssChapter';

const PbssChapterScreen = () => {
  return <PbssChapterContainer />;
};

export default PbssChapterScreen;
